export default class AvatarSelector {
    #element
    #previewElement
    #uploadInput
    #clearAvatar

    constructor(element) {
        this.#element = element
        this.#previewElement = document.querySelector(element.dataset.target)
        this.#uploadInput = document.querySelector(element.getAttribute('data-upload-input'))
        this.#clearAvatar = document.getElementById('clearAvatar')

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new AvatarSelector(element))
    }

    #bindEvents() {
        this.#element.addEventListener('change', () => {
            this.#handleChange()
        })

        if (this.#uploadInput) {
            this.#uploadInput.addEventListener('done', (e) => {
                this.#clearAvatar.classList.remove('d-none')
                this.#element.selectedIndex = 0

                const photo = this.#uploadInput.files[0]
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.#previewElement.src = e.target.result
                }
                reader.readAsDataURL(photo)
            })
        }

        document.getElementById('clearAvatar').addEventListener('click', () => {
            this.#clearFileInput()
        })
    }

    #handleChange() {
        this.#clearFileInput()

        let selectedOption = this.#element.options[this.#element.selectedIndex]

        selectedOption.value
            ? (this.#previewElement.src = '/images/avatars/' + selectedOption.value + '.png')
            : (this.#previewElement.src = '')
    }

    #clearFileInput() {
        if (this.#uploadInput.value) {
            this.#uploadInput.value = null
            this.#uploadInput.dispatchEvent(new Event('clear'))

            this.#previewElement.src = ''

            this.#clearAvatar.classList.add('d-none')
        }
    }
}
